import React, {useState} from 'react';
import {View, ActivityIndicator, Platform} from 'react-native';
//import WebView from 'react-native-webview';
import WebView from '../components/webview';
import logger from './logger';
//import Pdf from 'react-native-pdf';
import Pdf from '../components/pdf';
import {ActivityLoaderColor, isWeb, white} from './utils';
const base64toBlob = data => {
   // Cut the prefix `data:application/pdf;base64` from the raw base 64
   const base64WithoutPrefix = data.substr(
      'data:application/pdf;base64,'.length,
   );

   const bytes = atob(base64WithoutPrefix);
   let length = bytes.length;
   let out = new Uint8Array(length);

   while (length--) {
      out[length] = bytes.charCodeAt(length);
   }

   return new Blob([out], {type: 'application/pdf'});
};
const PDFViewer = ({urlPath, isShowingByBase64Str, base64}) => {
   const [isLoading, setIsLoading] = useState(true);
   logger('Path or base64 string ' + urlPath);
   logger('isShowing base64 str ' + isShowingByBase64Str);
   const handleLoadEnd = () => {
      setIsLoading(false);
   };

   if (isShowingByBase64Str) {
      return (
         <View
            style={{
               flex: 1,
            }}>
            {Platform.OS === 'web' ? (
               <Pdf urlPath={urlPath} loading={setIsLoading} bgColor={white} />
            ) : (
               <Pdf
                  source={{uri: urlPath}}
                  style={{flex: 1, width: '100%', height: '100%'}}
                  onLoadComplete={() => {
                     setIsLoading(false);
                  }}
                  onPageChanged={() => {}}
                  onError={() => {
                     setIsLoading(false);
                  }}
                  onPressLink={() => {}}
               />
            )}

            {isLoading && !isWeb && (
               <View
                  style={{
                     position: 'absolute',
                     top: 0,
                     bottom: 0,
                     left: 0,
                     right: 0,
                     justifyContent: 'center',
                     alignItems: 'center',
                  }}>
                  <ActivityIndicator size="large" color={ActivityLoaderColor} />
               </View>
            )}
         </View>
      );
   }
   // eslint-disable-next-line react-hooks/rules-of-hooks
   React.useEffect(() => {
      if (isLoading && Platform.OS === 'web') {
         setTimeout(() => {
            setIsLoading(false);
         }, 3000);
      }
   }, [isLoading]);

   return (
      <View
         style={{
            flex: 1,
            ...Platform.select({
               web: {
                  flex: null,
               },
            }),
         }}>
         <WebView
            source={{uri: urlPath}}
            javaScriptEnabled={true}
            domStorageEnabled={true}
            scalesPageToFit={true}
            onLoadEnd={handleLoadEnd}
            scrollEnabled={true}
         />

         {isLoading && (
            <View
               style={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  justifyContent: 'center',
                  alignItems: 'center',
               }}>
               <ActivityIndicator size="large" color={ActivityLoaderColor} />
            </View>
         )}
      </View>
   );
};

export default PDFViewer;
